import { render } from "./HighMath.vue?vue&type=template&id=45be13ae&ts=true"
import script from "./HighMath.vue?vue&type=script&lang=ts"
export * from "./HighMath.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__